import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellAllSharesUncollectedShares.scss';

import { SELL_ALL_SHARES_UNCOLLECTED_SHARES } from '../../../redux/modules/modals/modals.module';
import { updateSellFund } from '../../../redux/modules/sellTransaction/sellTransaction.module';
import Button from '../../Shared/Button/Button';
import If from '../../Shared/If/If';
import {
  calculateAndFormatUnixDates,
  futureDate,
} from '../../../utils/dates/date-utility';
import { formatShares } from '../../../utils/utils';
import words from '../../../utils/words';
import { ButtonType } from '../../Shared/Button/types';

const SellAllSharesUncollectedShares = ({
  closeModal,
  fund: {
    agreementID,
    hasMultipleTransactionsUncollected,
    hasUncollectedSharesDate,
    settlementDate,
    sweep,
    uncollectedSharesQuantity,
    availableShares,
    shares,
  },
  updateSellFund,
}) => {
  return (
    <div className="e2e-sell-all-shares-uncollected-shares-container">
      <div className="sell-all-shares-uncollected-shares-heading">
        {sweep
          ? `Uncollected ${words.shares}`
          : `Are you trying to close this ${words.fund}?`}
      </div>

      <div
        className="sell-all-shares-uncollected-shares-disclosure"
        id="uncollected-shares-disclosure-first"
      >
        <If test={hasUncollectedSharesDate}>
          {sweep
            ? `You `
            : `This ${words.fund} cannot be closed online as you `}
          currently hold{' '}
          {formatShares(uncollectedSharesQuantity, 'uncollected', words.shares)}
          .
          {hasMultipleTransactionsUncollected
            ? ` Uncollected ${words.shares} will start being `
            : ` All ${words.shares} will be `}
          available to {words.sell} online on{' '}
          {calculateAndFormatUnixDates(futureDate(settlementDate, 7))}.
        </If>
        <If test={!hasUncollectedSharesDate}>
          {sweep
            ? `You `
            : `This ${words.fund} cannot be closed online as you `}
          currently own {formatShares(shares - availableShares)} uncollected{' '}
          {words.shares} of this {words.fund}. {words.Shares} will be available
          to {words.sell} online 7 days after date of purchase.
        </If>
      </div>

      <div className="sell-all-shares-uncollected-shares-disclosure">
        To discuss {words.redemption} options regarding your uncollected{' '}
        {words.shares}, please{' '}
        <a
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          rel="noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        to speak with an associate.
      </div>

      <div className="sell-all-shares-uncollected-shares-button-container">
        <Button
          buttonType={ButtonType.PRIMARY}
          className="btn-trp-primary e2e-sell-all-shares-uncollected-shares-confirm-button sell-all-shares-uncollected-shares-ok-button"
          id={`sell-all-shares-uncollected-shares-modal-ok-btn-${agreementID}`}
          onClick={() => {
            updateSellFund({
              agreementID,
              closeout: false,
              grossAmount: undefined, // Undefined is used here to clear out grossAmount value so input for selected unit can be blank.
            });
            closeModal(SELL_ALL_SHARES_UNCOLLECTED_SHARES);
          }}
          styleName="sell-all-shares-uncollected-shares-ok-button"
        >
          OK
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSellFund,
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellAllSharesUncollectedShares
);
